import React, { Component } from "react";
import { Box, Breadcrumbs, Grid, Typography, Link } from "@mui/material";
import CtTxt from "./CustomTool/CtTxt";
import CtBtn from "./CustomTool/CtBtn";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import CtART from "./CustomTool/ResponsiveTable";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import { withRouter } from "../HOC/withRouter";
import { getRowOfRT } from "../SystemUtility/SystemUtility";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import { fetchBilling, fetchSite } from "./API";
import SiteMaster from "./SiteMaster";

class BillingMaster extends Component {
  state = {
    formData: {
      branchCode: "",
      branchName: "",
      siteName: "",
      billingName: "",
      billingAddress: "",
      panNo: "",
      gstNo: "",
      loadSite: "",
      bint_srno: 0,
    },

    BranchList: [],

    SiteList: [],

    columnsdata: [
      {
        header: "Branch Code",
        accessorKey: "vac_brcode",
        size: 100,
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        header: "Branch Name",
        accessorKey: "vac_brname",
        size: 100,
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        header: "Billing No",
        accessorKey: "bint_srno",
        size: 100,
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        header: "Site Name",
        accessorKey: "vac_sitename",
        size: 200,
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        header: "Billing Name",
        accessorKey: "vac_billingname",
        size: 200,
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        header: "Billing Address",
        accessorKey: "vac_billingadress",
        size: 250,
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        header: "PAN No.",
        accessorKey: "vac_pan",
        size: 150,
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        header: "GST No.",
        accessorKey: "vac_gstno",
        size: 150,
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
    ],

    rows: [],
    allRows: [],
    ARD: null,
  };

  componentDidMount() {
    localStorage.setItem("Heading", "Billing Master");
    this.props.verifyUserID(
      this.getInfo,
      this.props.setUserPrivileges,
      //   this.props.modules.Billing,
    );
    // this.ShortCut();
  }

  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name == "branchCode") {
          this.setBranchName();
        } else if (e.target.name == "branchName") {
          this.setBranchCode();
        }
      },
    );
  };

  handleLoadSite = () => {
    const { loadSite } = this.state.formData;
    if (!loadSite || loadSite.length === 0) {
      let rows = this.state.allRows;
      this.setState({
        rows,
      });
      return;
    }

    const filteredRows = this.state.allRows.filter(
      (row) => row.vac_sitename === loadSite,
    );
    console.log("filteredRows", filteredRows);

    this.setState({
      rows: filteredRows,
    });
  };

  setBranchName = () => {
    if (
      this.state.BranchList.length > 0 &&
      this.state.formData.branchCode.length > 0
    ) {
      this.state.BranchList.map((row) => {
        if (row.vac_brcode == this.state.formData.branchCode) {
          this.setState(
            {
              formData: {
                ...this.state.formData,
                branchName: row.vac_brname,
              },
            },
            () => {
              return;
            },
          );
        }
      });
    }
  };

  setBranchCode = () => {
    if (
      this.state.BranchList.length > 0 &&
      this.state.formData.branchName.length > 0
    ) {
      this.state.BranchList.map((row) => {
        if (row.vac_brname == this.state.formData.branchName) {
          this.setState(
            {
              formData: {
                ...this.state.formData,
                branchCode: row.vac_brcode,
              },
            },
            () => {
              return;
            },
          );
        }
      });
    }
  };

  handleARDonActionClick_Edit = (rtRow) => {
    const row = getRowOfRT(rtRow, [
      "bint_srno",
      "vac_brcode",
      "vac_brname",
      "vac_sitename",
      "vac_billingname",
      "vac_billingadress",
      "vac_pan",
      "vac_gstno",
    ]);
    const bint_srno = row.bint_srno,
      billingName = row.vac_billingname,
      billingAddress = row.vac_billingadress,
      siteName = row.vac_sitename,
      branchName = row.vac_brname,
      branchCode = row.vac_brcode,
      panNo = row.vac_pan,
      gstNo = row.vac_gstno;
    this.setState({
      formData: {
        ...this.state.formData,
        bint_srno,
        billingName,
        billingAddress,
        siteName,
        branchName,
        branchCode,
        panNo,
        gstNo,
      },
    });
    document.getElementById("branchName").focus();
  };

  handleARDonActionClick_Delete = (rtRow) => {
    const row = getRowOfRT(rtRow, ["bint_srno", "vac_billingname"]);
    this.DeleteData(row.bint_srno, row.vac_billingname);
  };
  getInfo = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "ListBillingMaster",
      vac_userid: localStorage.getItem("vac_userid"),
    };
    fetchBilling(reqData)
      .then((res) => {
        this.props.closeUpdateProcessing();
        let rows = res.data.BillingList,
          BranchList = res.data.BrNameList,
          SiteList = res.data.SiteNameData,
          rowsCount = rows.length;

        this.setState({
          rowsCount,
          rows,
          allRows: rows,
          BranchList,
          SiteList,
        });
      })
      .catch((error) => {
        console.log("Unknown error occurred in onFormLoad.", error);
      });
    document.getElementById("branchName").focus();
  };
  validationBilling = () => {
    let result = false;
    if (this.state.formData.branchCode.length <= 0) {
      this.props.toastErrorMsg("Enter Branch Code", "branchCode");
    } else if (this.state.formData.branchName.length <= 0) {
      this.props.toastErrorMsg("Enter Branch Name", "branchName");
    } else if (this.state.formData.siteName.length <= 0) {
      this.props.toastErrorMsg("Enter Site Name", "siteName");
    } else if (this.state.formData.billingName.length <= 0) {
      this.props.toastErrorMsg("Enter Billing Name", "billingName");
    } else if (this.state.formData.billingAddress.length <= 0) {
      this.props.toastErrorMsg("Enter Billing Address", "billingAddress");
    } else {
      result = true;
    }
    return result;
  };
  saveBilling = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "SaveBillingMaster",
      bint_srno: this.state.formData.bint_srno || 0,
      vac_brcode: this.state.formData.branchCode,
      vac_brname: this.state.formData.branchName,
      vac_sitename: this.state.formData.siteName,
      vac_billingname: this.state.formData.billingName,
      vac_billingadress: this.state.formData.billingAddress,
      vac_pan: this.state.formData.panNo,
      vac_gstno: this.state.formData.gstNo,
    };
    fetchBilling(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          let rows = [],
            rowsCount = rows.length;
          if (res.data.BillingList && res.data.BillingList.length > 0) {
            rows = res.data.BillingList;
            rowsCount = rows.length;
          }
          this.setState(
            {
              rows,
              allRows: rows,
              rowsCount,
            },
            () => {
              this.clearInfo();
            },
          );
        }
      })
      .catch((error) => {
        console.log("Unknown error occurred in Save Client .", error);
      });
  };

  clearInfo = () => {
    this.setState({
      formData: {
        branchCode: "",
        branchName: "",
        siteName: "",
        billingName: "",
        billingAddress: "",
        panNo: "",
        gstNo: "",
      },
    });
    document.getElementById("branchName").focus();
  };
  DeleteData = (bint_srno, billingName) => {
    if (bint_srno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={`Do you want to Delete  : ${billingName} ?`}
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteBilling(bint_srno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteBilling = (bint_srno) => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "DeleteBillingMaster",
      bint_srno: bint_srno,
    };
    fetchBilling(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          let rows = [],
            rowsCount = rows.length;
          if (res.data.BillingList && res.data.BillingList.length > 0) {
            rows = res.data.BillingList;
            rowsCount = rows.length;
          }
          this.setState(
            {
              rows,
              rowsCount,
              ARD: null,
            },
            () => {
              this.clearInfo();
            },
          );
        }
      })
      .catch((error) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in delete Lop Price. " + error,
        );
      });
    return false;
    // this.props.toastMsg("success", "AMC Client Name Delete Successfully");
  };

  handleCopyRow = (rtRow) => {
    const data = rtRow?.original;
    this.setState({
      formData: {
        branchName: "Bhavnagar",
        siteName: data.siteName,
        billingName: data.billingName,
        billingAddress: data.billingAddress,
        panNo: data.panNo,
        gstNo: data.gstNo,
      },
    });
  };
  onAddClickSite = () => {
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage={<SiteMaster />}
          defaultOpenDialog={true}
          handleOnClickNo={() => {
            this.getSiteList();
          }}
        />
      );
      this.setState({ ARD });
    });
  };

  getSiteList = () => {
    const reqData = {
      Op: "ListSiteMaster",
    };
    fetchSite(reqData)
      .then((res) => {
        this.props.toastMsg("success", "Site List Loaded Successfully");
        let SiteList = res.data.SiteList;

        this.setState({
          SiteList,
        });
      })
      .catch((error) => {
        console.log("Unknown error occurred in onFormLoad.", error);
      });
    // document.getElementById("txtBranchCode").focus();
  };

  Load = () => {};

  render() {
    return (
      <form>
        <Grid container spacing={2} justifyContent="flex-end">
          <Grid item>
            <CtBtn
              className="secondary-button"
              label="Save"
              iconName="save"
              onClick={this.saveBilling}
            />
          </Grid>
          <Grid item>
            <CtBtn
              label="New"
              className="new-button"
              iconName="new"
              onClick={this.clearInfo}
            />
          </Grid>
          <Grid item>
            <CtBtn
              label="Delete"
              className="delete-button"
              iconName="delete"
              onClick={() => {
                this.DeleteData(
                  this.state.formData.bint_srno,
                  this.state.formData.billingName,
                );
              }}
              disabled={this.state.formData.bint_srno > 0 ? false : true}
            />
          </Grid>
        </Grid>{" "}
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtCmbEditable
              id="branchName"
              label="Branch Name*"
              items={this.state.BranchList}
              handleOnChange={this.handleOnChange}
              value={this.state.formData.branchName}
              width={200}
              colID="vac_brname"
              maxLength={100}
              nextCtrlID={"siteName"}
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>

          <Grid item>
            <CtCmbEditable
              id="siteName"
              label="Site Name*"
              items={this.state.SiteList}
              handleOnChange={this.handleOnChange}
              value={this.state.formData.siteName}
              width={200}
              colID="vac_sitename"
              maxLength={100}
              bolVisibleOnAddClickIcon={true}
              onAddClick={this.onAddClickSite}
              nextCtrlID={"billingName"}
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>
        </Grid>
        <Grid container direction="row" spacing={2} marginTop={0}>
          <Grid item>
            <CtTxt
              id="billingName"
              label="Billing Name*"
              width={200}
              handleOnChange={this.handleOnChange}
              value={this.state.formData.billingName}
              maxLength={100}
              nextCtrlID={"billingAddress"}
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>

          <Grid item>
            <CtTxt
              id="billingAddress"
              label="Billing Address*"
              width={420}
              handleOnChange={this.handleOnChange}
              value={this.state.formData.billingAddress}
              maxLength={100}
              nextCtrlID={"panNo"}
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>
        </Grid>
        <Grid container direction="row" spacing={2} marginTop={0}>
          <Grid item>
            <CtTxt
              id="panNo"
              label="PAN No."
              width={200}
              handleOnChange={this.handleOnChange}
              value={this.state.formData.panNo}
              maxLength={100}
              nextCtrlID={"gstNo"}
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>

          <Grid item>
            <CtTxt
              id="gstNo"
              label="GST No."
              width={200}
              handleOnChange={this.handleOnChange}
              value={this.state.formData.gstNo}
              maxLength={100}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID={"loadSite"}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} marginTop={4} alignItems="center">
          <Grid item>
            <CtCmbEditable
              id="loadSite"
              label="Site Name*"
              items={this.state.SiteList}
              handleOnChange={this.handleOnChange}
              value={this.state.formData.loadSite}
              width={200}
              colID="vac_sitename"
              onKeyDown={this.props.onKeyDown}
              defaultAction={this.Load}
            />
          </Grid>

          <Grid item>
            <CtBtn
              label="LOAD"
              iconName="load"
              width={120}
              onClick={this.handleLoadSite}
            />
          </Grid>
        </Grid>
        <Grid marginTop={3}>
          <CtART
            rowsdata={this.state.rows}
            columnsdata={this.state.columnsdata}
            rowsPerPage={50}
            tblmaxHeight={400}
            density={"compact"}
            actionColSize={120}
            rowIconAction={[
              {
                label: "Edit",
                icon: "Edit",
                className: "secondary-button",
                onClick: this.handleARDonActionClick_Edit,
              },
              {
                label: "Copy",
                icon: <ContentCopyIcon fontSize="small" />,
                onClick: this.handleCopyRow,
              },
              {
                label: "Delete",
                onClick: this.handleARDonActionClick_Delete,
                icon: "delete",
                className: "delete-button",
              },
            ]}
            hideColIdList={["vac_brcode", "vac_brname"]}
          />
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

function WithNavigate(props) {
  let navigate = useNavigate();
  return <BillingMaster {...props} navigate={navigate} />;
}
export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps,
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
